import { connect } from 'react-redux'
import Scoring from '../../components/content/scoring'
import {
  setRoundStatus,
  toggleRoundOptions,
  selectTournamentToggleModal,
  setSelectedDefaultRoundTournament,
  setSelectedLiveActivityTournament,
  setDefaultRoundTournament,
  walkingScorerStationToggleModal,
  saveWalkingScorerStationSettings,
  popCheckpointWarningToggleModal,
  confirmDisableMobileScoring,
} from '../../actions/index'

// const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch, ownProps) => ({
  setRoundStatus: (status, url, roundId, data) => dispatch(setRoundStatus(ownProps.widgetId, url, status, roundId, data)),
  toggleRoundOptions: (url, option, roundId) => dispatch(toggleRoundOptions(ownProps.widgetId, url, option, roundId)),
  refresh: () => dispatch(ownProps.refresh),
  selectTournamentToggleModal: (visibility) => dispatch(selectTournamentToggleModal(ownProps.widgetId, visibility)),
  setSelectedDefaultRoundTournament: (selected) => dispatch(setSelectedDefaultRoundTournament(ownProps.widgetId, selected)),
  setSelectedLiveActivityTournament: (selected) => dispatch(setSelectedLiveActivityTournament(ownProps.widgetId, selected)),
  setDefaultRoundTournament: (path, tournamentId, liveActivityTournamentSpecId) => dispatch(setDefaultRoundTournament(ownProps.widgetId, path, tournamentId, liveActivityTournamentSpecId)),
  walkingScorerStationToggleModal: (visibility) => dispatch(walkingScorerStationToggleModal(ownProps.widgetId, visibility)),
  saveWalkingScorerStationSettings: (path, newSettings) => dispatch(saveWalkingScorerStationSettings(ownProps.widgetId, path, newSettings)),
  popCheckpointWarningToggleModal: (visibility) => dispatch(popCheckpointWarningToggleModal(ownProps.widgetId, visibility)),
  confirmDisableMobileScoring: (url, roundId) => dispatch(confirmDisableMobileScoring(ownProps.widgetId, url, roundId)),
})

export default connect(
  null,
  mapDispatchToProps,
)(Scoring)
